var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSentinel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 19,
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.83398 17.6667C7.83398 17.6667 14.334 14.4667 14.334 9.66675V4.06675L7.83398 1.66675L1.33398 4.06675V9.66675C1.33398 14.4667 7.83398 17.6667 7.83398 17.6667Z",
  stroke: "#B5B5B5",
  strokeWidth: 1.63333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83398 6.4668V9.6668",
  stroke: "#B5B5B5",
  strokeWidth: 1.63333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83398 12.8667H7.84198",
  stroke: "#B5B5B5",
  strokeWidth: 1.63333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSentinel;